import React, { useState, useEffect } from 'react';
import './App.css';

// ==========================================
// CORE PAGES IMPORTS
// ==========================================
import LandingPage from './pages/Landing';
import AboutPage from './pages/AboutUs';
import ContactPage from './pages/Contact';
import LoginPage from './pages/auth/Login';
import PrivacyPolicyPage from './pages/PrivacyPolicy';

// ==========================================
// STUDENT DASHBOARD COMPONENTS
// ==========================================
import StudentDashboard from './pages/student/Studentdashboard';
import StudentAttendance from './pages/student/StudentAttendance'; // NEW: Student Attendance Page
import StudentProfile from './pages/student/Studentprofile';
import StudentFees from './pages/student/Studentfees';
import StudentInternship from './pages/student/Studentinternship';
import StudentCard from './pages/student/Studentcard';
import StudentForm from './pages/student/Studentform';
import StudentGrievance from './pages/student/Studentgrievance';
import StudentMarks from './pages/student/Studentmarks';
import StudentAssignment from './pages/student/Studentassignment';
import StudentMarksReview from './pages/student/Studentmarksreview';
import StudentLeave from './pages/student/Studentleave'; // NEW: Student Leave Application Page
import StudentLibrary from './pages/student/StudentLibrary';
import StudentElearning from './pages/student/StudentElearning';
import StudentClassNotes from './pages/student/StudentClassNotes';
import StudentHolidays from './pages/student/StudentHolidays';

// ==========================================
// TEACHER DASHBOARD COMPONENTS
// ==========================================
import TeacherDashboard from './pages/teacher/Teacherdashboard';
import TeacherProfile from './pages/teacher/Teacherprofile';
import TeacherAttendance from './pages/teacher/Teacherattendance';
import TeacherTimetable from './pages/teacher/Teachertimetable';
import TeacherGrievance from './pages/teacher/Teachergrievance';
import TeacherRequisition from './pages/teacher/Teacherrequisition';
import Teacherstudentassignment from './pages/teacher/Teacherstudentassignment';
import TeacherMarksSubmission from './pages/teacher/Teachermarkssubmission';
import TeacherStudentsLeaveApplication from './pages/teacher/Teacherstudentsleaveapplication';
import TeacherElearning from './pages/teacher/TeacherElearning';
import TeacherClassNotes from './pages/teacher/TeacherClassNotes';
import TeacherHolidays from './pages/teacher/TeacherHolidays';

// ==========================================
// HOD DASHBOARD COMPONENTS
// ==========================================
import HodDashboard from './pages/hod/Hoddashboard';
import HodProfile from './pages/hod/Hodprofile';
import HodViewGrievances from './pages/hod/Hodviewgrievance';
import HodInternshipAttendance from './pages/hod/Hodinternshipattendance';
import HodLabReview from './pages/hod/Hodlabreview';
import HodTeacherAttendance from './pages/hod/Hodteacherattendance';
import HodReviewRequests from './pages/hod/Hodreviewrequests';
import HodSupplyApplications from './pages/hod/Hodsupplyapplications';
import HodRequisition from './pages/hod/Hodrequisition';
// import HodSalaryCounter from './pages/hod/Hodsalarycounter';

// ==========================================
// ADMIN DASHBOARD COMPONENTS - CORE
// ==========================================
import AdminDashboard from './pages/admin/Admindashboard';
import AdminAttendanceManage from './pages/admin/Adminattendancemanage';
import AdminAttendanceCollectReport from './pages/admin/AdminAttendanceCollectReport';
import AdminTeacherAttendanceManage from './pages/admin/Adminteacherattendancemanage';
// import AdminFeeManage from './pages/admin/Adminfeemanage';
import AdminStudentManage from './pages/admin/Adminstudentmanage';
import AdminTeacherManage from './pages/admin/Adminteachermanage';

// ==========================================
// ADMIN DASHBOARD COMPONENTS - EXTENDED
// ==========================================
import AdminGrievanceManagement from './pages/admin/Admingrievancemanage';
import AdminHODManagement from './pages/admin/Adminhodmanage';
import AdminInternshipManagement from './pages/admin/Admininternshipmanage';
import AdminLabEquipmentManagement from './pages/admin/Adminlabmanage';
import AdminLoginManagement from './pages/admin/Adminloginmanage';
import AdminLoginLogsManagement from './pages/admin/Adminloginlogsmanage';
import AdminTimetableManagement from './pages/admin/Admintimetablemanage';
import AdminNoticeManagement from './pages/admin/Adminnoticemanage';
import AdminStudentCardManage from './pages/admin/AdminStudentcardmanage';
import AdminMarksCardAssign from './pages/admin/Adminassignmarks';
import AdminRequisition from './pages/admin/Adminrequisition';
import AdminAttendanceSubjects from './pages/admin/Adminmanagesubjects';
import AttendanceAnalytics from './pages/admin/AttendanceAnalytics';
import AdminExamScheduleManage from './pages/admin/AdminExamScheduleManage';

// ⭐ NEW: TRAINING MANAGEMENT IMPORT
import AdminTrainingManagement from './pages/admin/AdminTrainingManagement';

// ⭐ NEW: PUSH NOTIFICATIONS IMPORT
import AdminNotifications from './pages/admin/Adminnotifications';
import AdminElearning from './pages/admin/AdminElearning';
import AdminHolidayManage from './pages/admin/AdminHolidayManage';

// ==========================================
// ACCOUNTS DASHBOARD COMPONENTS
// ==========================================
import AccountsDashboard from './pages/accounts/accountsdashbooard';
import AccountsCertificates from './pages/accounts/AccountsCertificates';
import AccountsInventory from './pages/accounts/AccountsInventory';
import AccountsPerformance from './pages/accounts/AccountsPerformance';
import AccountsWorkOrders from './pages/accounts/AccountsWorkOrders';
import AccountsVendorManagement from './pages/accounts/AccountsVendorManagement';
import AccountsFeeManage from './pages/accounts/Accountsfeemanage';
import AccountsFeeStructure from './pages/accounts/Accountsfeesstructure';
import AccountsSalaryCounter from './pages/accounts/AccountsSalaryCounter';
import AccountsReports from './pages/accounts/AccountsReports';

// ==========================================
// VENDOR DASHBOARD COMPONENTS
// ==========================================
import VendorDashboard from './pages/vendor/vendordashboard';
import LiveBidding from './pages/vendor/livebidding';
import VendorMyBids from './pages/vendor/mybids';

// ==========================================
// PARENT DASHBOARD COMPONENTS
// ==========================================
import ParentDashboard from './pages/parent/Parentdashboard';
import ParentAcademicPerformance from './pages/parent/Parentacademicperformance';
import ParentFeesStatus from './pages/parent/Parentfeesstatus';
import ParentHolidays from './pages/parent/Parentsholidays';
import ParentEmergencyAlert from './pages/parent/ParentEmergencyalert';


// ==========================================
// LIBRARY DASHBOARD COMPONENTS
// ==========================================
import LibraryDashboard from './pages/Library/LibraryDashboard';
import LibraryNewArrivals from './pages/Library/LibraryNewArrivals';
import LibraryCatalog from './pages/Library/LibraryCatalog';
import LibraryCategories from './pages/Library/LibraryCategories';
import LibraryIssue from './pages/Library/LibraryIssue';
import LibraryReturn from './pages/Library/LibraryReturn';
import LibraryMembers from './pages/Library/LibraryMembers';
import LibraryRequests from './pages/Library/LibraryRequests';
import LibraryOverdue from './pages/Library/LibraryOverdue';
import LibraryFines from './pages/Library/LibraryFines';

// ==========================================
// EXAM CELL DASHBOARD COMPONENTS
// ==========================================
import ExamCellDashboard from './pages/examcell/Examcelldashboard';
import ExamCellAdmitCard from './pages/examcell/Examcelladmitcard';
import ExamCellAdmitFormat from './pages/examcell/Examcelladmitformat';
import ExamCellExamForm from './pages/examcell/Examcellexamform';
import ExamCellForms from './pages/examcell/Examcellforms';
import ExamCellSemesterFees from './pages/examcell/Examcellsemesterfees';
import ExamCellGrievance from './pages/examcell/Examcellgrievance';

// ==========================================
// UTILITY COMPONENTS
// ==========================================

// Error Boundary Component
const ErrorBoundary = ({ children, componentName, onNavigate }) => {
  const [hasError, setHasError] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleError = (error, errorInfo) => {
      console.error(`Error in ${componentName}:`, error, errorInfo);
      setHasError(true);
      setError(error);
    };

    const handleUnhandledRejection = (event) => {
      console.error(`Unhandled promise rejection in ${componentName}:`, event.reason);
      setHasError(true);
      setError(new Error('Unhandled promise rejection'));
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, [componentName]);

  if (hasError) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f4f7fa',
        padding: '2rem'
      }}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '16px',
          padding: '3rem',
          textAlign: 'center',
          maxWidth: '500px',
          boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
          border: '1px solid #e0e0e0'
        }}>
          <div style={{ fontSize: '4rem', marginBottom: '1rem', color: '#ff6b6b' }}>⚠️</div>
          <h3 style={{ color: '#dc2626', marginBottom: '1rem', fontSize: '1.5rem', fontWeight: '600' }}>
            Component Error
          </h3>
          <p style={{ color: '#666', marginBottom: '1rem', lineHeight: 1.6 }}>
            There was an error loading the <strong>{componentName}</strong> component.
          </p>
          <div style={{
            backgroundColor: '#fef2f2',
            border: '1px solid #fecaca',
            borderRadius: '8px',
            padding: '1rem',
            marginBottom: '2rem',
            fontSize: '0.9rem',
            color: '#991b1b'
          }}>
            <strong>Error Details:</strong> {error?.message || 'Unknown error occurred'}
          </div>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button
              onClick={() => {
                setHasError(false);
                setError(null);
                window.location.reload();
              }}
              style={{
                backgroundColor: '#238548',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                padding: '0.75rem 1.5rem',
                cursor: 'pointer',
                fontSize: '1rem',
                fontWeight: '500',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#1e7139'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#238548'}
            >
              🔄 Reload Page
            </button>
            <button
              onClick={() => onNavigate('home')}
              style={{
                backgroundColor: '#6b7280',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                padding: '0.75rem 1.5rem',
                cursor: 'pointer',
                fontSize: '1rem',
                fontWeight: '500',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#4b5563'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#6b7280'}
            >
              🏠 Go Home
            </button>
          </div>
        </div>
      </div>
    );
  }

  return children;
};

// Coming Soon Component for pages that don't exist yet
const ComingSoonDashboard = ({ userType, onNavigate, userInfo, pageName }) => {
  const handleLogout = () => {
    sessionStorage.clear();
    localStorage.clear();
    onNavigate('home');
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f0fdfa 0%, #dcfce7 50%, #e6fffa 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '20px',
        padding: '3rem',
        textAlign: 'center',
        maxWidth: '600px',
        width: '100%',
        boxShadow: '0 25px 50px rgba(0, 0, 0, 0.1)',
        border: '1px solid rgba(15, 118, 110, 0.1)'
      }}>
        <div style={{ fontSize: '5rem', marginBottom: '1.5rem' }}>🚧</div>

        <h1 style={{
          fontSize: '2.5rem',
          fontWeight: 'bold',
          color: '#1f2937',
          marginBottom: '1rem'
        }}>
          {pageName || `${userType} Dashboard`}
        </h1>

        <div style={{ fontSize: '1.3rem', color: '#6b7280', marginBottom: '1rem' }}>
          Under Development
        </div>

        <div style={{ fontSize: '1rem', color: '#9ca3af', marginBottom: '2rem', lineHeight: 1.6 }}>
          This feature is currently being developed and will be available soon.
          Thank you for your patience!
        </div>

        <div style={{
          backgroundColor: '#f0fdf4',
          borderRadius: '12px',
          padding: '1.5rem',
          marginBottom: '2rem',
          fontSize: '1rem',
          color: '#166534',
          border: '1px solid #bbf7d0'
        }}>
          <div style={{ fontWeight: '600', marginBottom: '0.5rem' }}>👋 Welcome Back!</div>
          <div>{userInfo?.name || 'User'} (ID: {userInfo?.id || 'N/A'})</div>
          <div style={{ fontSize: '0.9rem', marginTop: '0.5rem', opacity: 0.8 }}>
            Role: {userInfo?.role ? userInfo.role.charAt(0).toUpperCase() + userInfo.role.slice(1) : 'N/A'}
          </div>
        </div>

        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
          <button
            onClick={() => onNavigate(userType.toLowerCase() + '-dashboard')}
            style={{
              backgroundColor: '#0f766e',
              color: 'white',
              border: 'none',
              borderRadius: '12px',
              padding: '12px 24px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#059669';
              e.target.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#0f766e';
              e.target.style.transform = 'translateY(0)';
            }}
          >
            📊 Back to Dashboard
          </button>

          <button
            onClick={() => onNavigate('home')}
            style={{
              backgroundColor: '#6b7280',
              color: 'white',
              border: 'none',
              borderRadius: '12px',
              padding: '12px 24px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#4b5563';
              e.target.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#6b7280';
              e.target.style.transform = 'translateY(0)';
            }}
          >
            🏠 Home
          </button>

          <button
            onClick={handleLogout}
            style={{
              backgroundColor: '#dc2626',
              color: 'white',
              border: 'none',
              borderRadius: '12px',
              padding: '12px 24px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#b91c1c';
              e.target.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#dc2626';
              e.target.style.transform = 'translateY(0)';
            }}
          >
            🚪 Logout
          </button>
        </div>
      </div>
    </div>
  );
};

// ==========================================
// MAIN APP COMPONENT
// ==========================================
function App() {
  // ==========================================
  // STATE MANAGEMENT
  // ==========================================

  // Initialize state from localStorage or Hash to persist across refreshes
  const [currentPage, setCurrentPage] = useState(() => {
    const hashPage = window.location.hash.slice(1);
    const savedPage = localStorage.getItem('currentPage');
    return hashPage || savedPage || 'home';
  });

  // Check if user is logged in from both session and local storage
  const isLoggedIn = sessionStorage.getItem('isLoggedIn') === 'true' ||
    localStorage.getItem('isLoggedIn') === 'true';

  const userInfo = JSON.parse(sessionStorage.getItem('userInfo') ||
    localStorage.getItem('userInfo') || '{}');

  // ==========================================
  // NAVIGATION MANAGEMENT
  // ==========================================

  // Enhanced navigation function that persists route
  const handleNavigation = (page) => {
    // console.log(`🔄 Navigating to: ${page}`);
    setCurrentPage(page);

    // Store current page in localStorage for persistence across refreshes
    localStorage.setItem('currentPage', page);

    // Update browser history
    if (window.history.pushState) {
      window.history.pushState({ page }, '', `#${page}`);
    }

    // If navigating to login or home, clear auth data
    if (page === 'login' || page === 'home') {
      // console.log('🧹 Clearing authentication data');
      sessionStorage.clear();
      localStorage.removeItem('isLoggedIn');
      localStorage.removeItem('userInfo');
      localStorage.removeItem('token');
      localStorage.removeItem('currentPage');
    }
  };

  // ==========================================
  // ROUTE DEFINITIONS
  // ==========================================

  // Define all protected pages that require authentication
  const protectedRoutes = {
    // Student routes - UPDATED WITH ATTENDANCE PAGE AND LEAVE APPLICATION
    student: [
      'student-dashboard', 'student-attendance', 'student-profile', 'student-fees', 'student-internship',
      'student-cards', 'student-forms', 'student-marks', 'student-marks-review', 'student-assignments',
      'student-leave', 'student-grievance', 'student-elearning', 'student-library', 'student-class-notes', 'student-holidays'
    ],

    // Teacher routes
    teacher: [
      'teacher-dashboard', 'teacher-profile', 'teacher-attendance',
      'teacher-timetable', 'teacher-requisition', 'teacher-student-assignment', 'teacher-grievance', 'teacher-marks-submission',
      'teacher-student-leave-application', 'teacher-elearning', 'teacher-class-notes', 'teacher-holidays'
    ],

    // HOD routes - WITH REQUISITION
    hod: [
      'hod-dashboard', 'hod-profile', 'hod-grievances', 'hod-internship',
      'hod-lab-review', 'hod-teacher-attendance', 'hod-review-requests',
      'hod-supply-applications', 'hod-requisition' // , 'hod-salary-counter' - MOVED TO ACCOUNTS
    ],

    // Admin routes - UPDATED WITH TRAINING MANAGEMENT AND NOTIFICATIONS
    admin: [
      'admin-dashboard', 'admin-students', 'admin-teachers', 'admin-attendance',
      'admin-teacher-attendance', 'admin-fees', 'admin-grievances', 'admin-hods', 'admin-internships',
      'admin-labs', 'admin-requisition', 'admin-training', // ⭐ NEW ROUTE
      'admin-login-credentials', 'admin-login-logs',
      'admin-student-cards', 'admin-timetable', 'admin-attendance-subjects', 'admin-marks', 'admin-notices', 'admin-attendance-analytics',
      'admin-notifications', // ⭐ NEW: PUSH NOTIFICATIONS ROUTE
      'admin-attendance-collect-report',
      'admin-exam-schedule', // Exam Schedule Management
      'admin-elearning', // 📚 E-Learning Management
      'admin-holidays' // 🏖️ Holiday Calendar
    ],

    // Parent routes
    parent: [
      'parent-dashboard', 'parent-academic-performance', 'parent-fees-status',
      'parent-holidays', 'parent-emergency-alert'
    ],

    // Accounts routes
    accounts: ['accounts-dashboard', 'accounts-certificates', 'accounts-inventory', 'accounts-performance', 'accounts-work-orders', 'accounts-vendor-management', 'accounts-fee', 'accounts-fees-structure', 'accounts-salary-counter', 'accounts-reports'],

    // Vendor routes
    vendor: ['vendor-dashboard', 'live-bidding'],

    // Library routes - protected for librarian role
    librarian: ['library-dashboard', 'library-new-arrivals', 'library-catalog', 'library-categories', 'library-issue', 'library-return', 'library-members', 'library-requests', 'library-overdue', 'library-fines'],

    // Super Admin routes
    superadmin: ['superadmin-dashboard'],

    // Exam Cell routes (Temporarily Public)
    // examcell: [
    //   'examcell-dashboard', 'examcell-admitcard', 'examcell-examform',
    //   'examcell-forms', 'examcell-semesterfees', 'examcell-grievance'
    // ]
  };

  // Get all protected pages in a flat array
  const allProtectedPages = Object.values(protectedRoutes).flat();

  // ==========================================
  // EFFECTS
  // ==========================================

  // Handle browser back/forward buttons and URL hash changes
  useEffect(() => {
    const handlePopState = (event) => {
      const page = event.state?.page || window.location.hash.slice(1) || 'home';
      // console.log(`🔙 Browser navigation detected: ${page}`);

      if (isLoggedIn ||
        ['home', 'about', 'contact', 'login'].includes(page) ||
        page.startsWith('examcell-')) {
        setCurrentPage(page);
        localStorage.setItem('currentPage', page);
      } else {
        setCurrentPage('login');
        localStorage.setItem('currentPage', 'login');
      }
    };

    const handleHashChange = () => {
      const page = window.location.hash.slice(1) || 'home';
      // console.log(`🔗 Hash change detected: ${page}`);
      if (page !== currentPage) {
        setCurrentPage(page);
        localStorage.setItem('currentPage', page);
      }
    };

    window.addEventListener('popstate', handlePopState);
    window.addEventListener('hashchange', handleHashChange);

    // Set initial hash if it doesn't exist
    if (!window.location.hash && currentPage !== 'home') {
      window.location.hash = currentPage;
    }

    return () => {
      window.removeEventListener('popstate', handlePopState);
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, [isLoggedIn, currentPage]);

  // Check authentication on mount and page change
  useEffect(() => {
    const checkAuth = () => {
      // console.log(`🔐 Checking authentication for page: ${currentPage}`);
      // console.log(`📊 User info:`, userInfo);
      // console.log(`🔑 Is logged in:`, isLoggedIn);

      // Check if page requires authentication
      if (allProtectedPages.includes(currentPage) && !isLoggedIn) {
        // console.log('🔐 Redirecting to login - not authenticated');
        handleNavigation('login');
        return;
      }

      // If logged in but on a wrong role dashboard, redirect to correct one
      if (isLoggedIn && userInfo.role) {
        const roleDashboards = {
          student: 'student-dashboard',
          teacher: 'teacher-dashboard',
          hod: 'hod-dashboard',
          admin: 'admin-dashboard',
          parent: 'parent-dashboard',
          accounts: 'accounts-dashboard',
          vendor: 'vendor-dashboard',
          librarian: 'library-dashboard',
          superadmin: 'superadmin-dashboard',
          examcell: 'examcell-dashboard'
        };

        // If on login page but already logged in, go to dashboard
        if (currentPage === 'login') {
          // console.log('🏠 Redirecting to dashboard - already authenticated');
          const targetDashboard = roleDashboards[userInfo.role] || 'home';
          handleNavigation(targetDashboard);
          return;
        }

        // Check if user is accessing wrong role's pages
        const currentRole = userInfo.role;
        const userRoutes = protectedRoutes[currentRole] || [];

        if (allProtectedPages.includes(currentPage) && !userRoutes.includes(currentPage)) {
          // console.log(`🚫 Role mismatch - redirecting ${currentRole} from unauthorized page`);
          handleNavigation(roleDashboards[currentRole] || 'home');
          return;
        }
      }
    };

    checkAuth();
  }, [currentPage, isLoggedIn, userInfo.role]);

  // ==========================================
  // COMPONENT WRAPPER
  // ==========================================

  const ComponentWrapper = ({ children, componentName }) => {
    return (
      <ErrorBoundary componentName={componentName} onNavigate={handleNavigation}>
        {children}
      </ErrorBoundary>
    );
  };

  // ==========================================
  // ROUTE RENDERING LOGIC
  // ==========================================

  const renderCurrentPage = () => {
    // console.log(`🎨 Rendering page: ${currentPage}`);

    // Authentication helper
    const requireAuth = (userRole, component) => {
      if (!isLoggedIn || (userRole && userInfo.role !== userRole)) {
        return <LoginPage onNavigate={handleNavigation} />;
      }
      return component;
    };

    switch (currentPage) {
      // ==========================================
      // PUBLIC PAGES
      // ==========================================
      case 'home':
        return (
          <ComponentWrapper componentName="LandingPage">
            <LandingPage onNavigate={handleNavigation} />
          </ComponentWrapper>
        );

      case 'about':
        return (
          <ComponentWrapper componentName="AboutPage">
            <AboutPage onNavigate={handleNavigation} />
          </ComponentWrapper>
        );

      case 'contact':
        return (
          <ComponentWrapper componentName="ContactPage">
            <ContactPage onNavigate={handleNavigation} />
          </ComponentWrapper>
        );

      case 'login':
        return (
          <ComponentWrapper componentName="LoginPage">
            <LoginPage onNavigate={handleNavigation} />
          </ComponentWrapper>
        );

      case 'privacypolicy':
        return (
          <ComponentWrapper componentName="PrivacyPolicyPage">
            <PrivacyPolicyPage onNavigate={handleNavigation} />
          </ComponentWrapper>
        );

      // ==========================================
      // STUDENT DASHBOARD ROUTES
      // ==========================================
      case 'student-dashboard':
        return requireAuth('student',
          <ComponentWrapper componentName="StudentDashboard">
            <StudentDashboard onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      // NEW: STUDENT ATTENDANCE PAGE - DETAILED ATTENDANCE VIEW
      case 'student-attendance':
        return requireAuth('student',
          <ComponentWrapper componentName="StudentAttendance">
            <StudentAttendance onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'student-profile':
        return requireAuth('student',
          <ComponentWrapper componentName="StudentProfile">
            <StudentProfile onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'student-fees':
        return requireAuth('student',
          <ComponentWrapper componentName="StudentFees">
            <StudentFees onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'student-internship':
        return requireAuth('student',
          <ComponentWrapper componentName="StudentInternship">
            <StudentInternship onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'student-cards':
        return requireAuth('student',
          <ComponentWrapper componentName="StudentCard">
            <StudentCard onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'student-forms':
        return requireAuth('student',
          <ComponentWrapper componentName="StudentForm">
            <StudentForm onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'student-marks':
        return requireAuth('student',
          <ComponentWrapper componentName="StudentMarks">
            <StudentMarks onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'student-marks-review':
        return requireAuth('student',
          <ComponentWrapper componentName="StudentMarksReview">
            <StudentMarksReview onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'student-assignments':
        return requireAuth('student',
          <ComponentWrapper componentName="StudentAssignment">
            <StudentAssignment onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'student-leave':
        return requireAuth('student',
          <ComponentWrapper componentName="StudentLeave">
            <StudentLeave onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'student-grievance':
        return requireAuth('student',
          <ComponentWrapper componentName="StudentGrievance">
            <StudentGrievance onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'student-library':
        return requireAuth('student',
          <ComponentWrapper componentName="StudentLibrary">
            <StudentLibrary onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'student-elearning':
        return requireAuth('student',
          <ComponentWrapper componentName="StudentElearning">
            <StudentElearning onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'student-class-notes':
        return requireAuth('student',
          <ComponentWrapper componentName="StudentClassNotes">
            <StudentClassNotes onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'student-holidays':
        return requireAuth('student',
          <ComponentWrapper componentName="StudentHolidays">
            <StudentHolidays onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      // ==========================================
      // TEACHER DASHBOARD ROUTES
      // ==========================================
      case 'teacher-dashboard':
        return requireAuth('teacher',
          <ComponentWrapper componentName="TeacherDashboard">
            <TeacherDashboard onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'teacher-profile':
        return requireAuth('teacher',
          <ComponentWrapper componentName="TeacherProfile">
            <TeacherProfile onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'teacher-attendance':
        return requireAuth('teacher',
          <ComponentWrapper componentName="TeacherAttendance">
            <TeacherAttendance onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'teacher-timetable':
        return requireAuth('teacher',
          <ComponentWrapper componentName="TeacherTimetable">
            <TeacherTimetable onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'teacher-grievance':
        return requireAuth('teacher',
          <ComponentWrapper componentName="TeacherGrievance">
            <TeacherGrievance onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );
      case 'teacher-requisition':
        return requireAuth('teacher',
          <ComponentWrapper componentName="TeacherRequisition">
            <TeacherRequisition onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'teacher-student-assignment':
        return requireAuth('teacher',
          <ComponentWrapper componentName="Teacherstudentassignment">
            <Teacherstudentassignment onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'teacher-marks-submission':
        return requireAuth('teacher',
          <ComponentWrapper componentName="TeacherMarksSubmission">
            <TeacherMarksSubmission onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'teacher-student-leave-application':
        return requireAuth('teacher',
          <ComponentWrapper componentName="TeacherStudentsLeaveApplication">
            <TeacherStudentsLeaveApplication onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'teacher-elearning':
        return requireAuth('teacher',
          <ComponentWrapper componentName="TeacherElearning">
            <TeacherElearning onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'teacher-class-notes':
        return requireAuth('teacher',
          <ComponentWrapper componentName="TeacherClassNotes">
            <TeacherClassNotes onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'teacher-holidays':
        return requireAuth('teacher',
          <ComponentWrapper componentName="TeacherHolidays">
            <TeacherHolidays onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      // ==========================================
      // HOD DASHBOARD ROUTES
      // ==========================================
      case 'hod-dashboard':
        return requireAuth('hod',
          <ComponentWrapper componentName="HodDashboard">
            <HodDashboard onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'hod-profile':
        return requireAuth('hod',
          <ComponentWrapper componentName="HodProfile">
            <HodProfile onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'hod-grievances':
        return requireAuth('hod',
          <ComponentWrapper componentName="HodViewGrievances">
            <HodViewGrievances onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'hod-internship':
        return requireAuth('hod',
          <ComponentWrapper componentName="HodInternshipAttendance">
            <HodInternshipAttendance onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'hod-lab-review':
        return requireAuth('hod',
          <ComponentWrapper componentName="HodLabReview">
            <HodLabReview onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      // ==========================================
      // EXAM CELL DASHBOARD ROUTES
      // ==========================================
      case 'examcell-dashboard':
        return (
          <ComponentWrapper componentName="ExamCellDashboard">
            <ExamCellDashboard onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'examcell-admitcard':
        return (
          <ComponentWrapper componentName="ExamCellAdmitCard">
            <ExamCellAdmitCard onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'examcell-examform':
        return (
          <ComponentWrapper componentName="ExamCellExamForm">
            <ExamCellExamForm onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'examcell-forms':
        return (
          <ComponentWrapper componentName="ExamCellForms">
            <ExamCellForms onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'examcell-semesterfees':
        return (
          <ComponentWrapper componentName="ExamCellSemesterFees">
            <ExamCellSemesterFees onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'examcell-grievance':
        return (
          <ComponentWrapper componentName="ExamCellGrievance">
            <ExamCellGrievance onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'hod-teacher-attendance':
        return requireAuth('hod',
          <ComponentWrapper componentName="HodTeacherAttendance">
            <HodTeacherAttendance onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'hod-review-requests':
        return requireAuth('hod',
          <ComponentWrapper componentName="HodReviewRequests">
            <HodReviewRequests onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'hod-supply-applications':
        return requireAuth('hod',
          <ComponentWrapper componentName="HodSupplyApplications">
            <HodSupplyApplications onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      // HOD REQUISITION ROUTE
      case 'hod-requisition':
        return requireAuth('hod',
          <ComponentWrapper componentName="HodRequisition">
            <HodRequisition onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'hod-salary-counter':
        return requireAuth('hod',
          <ComponentWrapper componentName="HodSalaryCounter">
            {/* <HodSalaryCounter onNavigate={handleNavigation} userInfo={userInfo} /> */}
            <div style={{ padding: '2rem', textAlign: 'center' }}>Salary Counter has been moved to Accounts Portal.</div>
          </ComponentWrapper>
        );

      // ==========================================
      // ACCOUNTS DASHBOARD ROUTES
      // ==========================================
      case 'admin-dashboard':
        return requireAuth('admin',
          <ComponentWrapper componentName="AdminDashboard">
            <AdminDashboard onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'admin-students':
        return requireAuth('admin',
          <ComponentWrapper componentName="AdminStudentManage">
            <AdminStudentManage onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'admin-teachers':
        return requireAuth('admin',
          <ComponentWrapper componentName="AdminTeacherManage">
            <AdminTeacherManage onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'admin-attendance':
        return requireAuth('admin',
          <ComponentWrapper componentName="AdminAttendanceManage">
            <AdminAttendanceManage onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      // ⭐ NEW: TEACHER ATTENDANCE MANAGEMENT - FULLY FUNCTIONAL
      case 'admin-teacher-attendance':
        return requireAuth('admin',
          <ComponentWrapper componentName="AdminTeacherAttendanceManage">
            <AdminTeacherAttendanceManage onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      /*
      case 'admin-fees':
        return requireAuth('admin',
          <ComponentWrapper componentName="AdminFeeManage">
            <AdminFeeManage onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );
      */

      // ==========================================
      // ADMIN DASHBOARD ROUTES - EXTENDED FEATURES
      // ==========================================
      case 'admin-grievances':
        return requireAuth('admin',
          <ComponentWrapper componentName="AdminGrievanceManagement">
            <AdminGrievanceManagement onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'admin-hods':
        return requireAuth('admin',
          <ComponentWrapper componentName="AdminHODManagement">
            <AdminHODManagement onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'admin-internships':
        return requireAuth('admin',
          <ComponentWrapper componentName="AdminInternshipManagement">
            <AdminInternshipManagement onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'admin-labs':
        return requireAuth('admin',
          <ComponentWrapper componentName="AdminLabEquipmentManagement">
            <AdminLabEquipmentManagement onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      // ⭐ ADMIN REQUISITION ROUTE - FULLY FUNCTIONAL
      case 'admin-requisition':
        return requireAuth('admin',
          <ComponentWrapper componentName="AdminRequisition">
            <AdminRequisition onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      // ⭐ NEW: TRAINING MANAGEMENT ROUTE
      case 'admin-training':
        return requireAuth('admin',
          <ComponentWrapper componentName="AdminTrainingManagement">
            <AdminTrainingManagement onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'admin-login-credentials':
        return requireAuth('admin',
          <ComponentWrapper componentName="AdminLoginManagement">
            <AdminLoginManagement onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'admin-login-logs':
        return requireAuth('admin',
          <ComponentWrapper componentName="AdminLoginLogsManagement">
            <AdminLoginLogsManagement onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'admin-timetable':
        return requireAuth('admin',
          <ComponentWrapper componentName="AdminTimetableManagement">
            <AdminTimetableManagement onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'admin-notices':
        return requireAuth('admin',
          <ComponentWrapper componentName="AdminNoticeManagement">
            <AdminNoticeManagement onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      // FEATURED: Student Card Management - FULLY WORKING
      case 'admin-student-cards':
        return requireAuth('admin',
          <ComponentWrapper componentName="AdminStudentCardManage">
            <AdminStudentCardManage onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      // ⭐ NEW: ATTENDANCE SUBJECTS MANAGEMENT - FULLY FUNCTIONAL
      case 'admin-attendance-subjects':
        return requireAuth('admin',
          <ComponentWrapper componentName="AdminAttendanceSubjects">
            <AdminAttendanceSubjects onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      // ⭐ NEW: EXAM SCHEDULE MANAGEMENT (for Admit Cards)
      case 'admin-exam-schedule':
        return requireAuth('admin',
          <ComponentWrapper componentName="AdminExamScheduleManage">
            <AdminExamScheduleManage onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      // ⭐ NEW: ATTENDANCE ANALYTICS
      case 'admin-attendance-analytics':
        return requireAuth('admin',
          <ComponentWrapper componentName="AttendanceAnalytics">
            <AttendanceAnalytics onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      // ATTENDANCE COLLECT REPORT
      case 'admin-attendance-collect-report':
        return requireAuth('admin',
          <ComponentWrapper componentName="AdminAttendanceCollectReport">
            <AdminAttendanceCollectReport onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      // FEATURED: Marks Card Management - FULLY WORKING
      case 'admin-marks':
        return requireAuth('admin',
          <ComponentWrapper componentName="AdminMarksCardAssign">
            <AdminMarksCardAssign onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      // ⭐ NEW: PUSH NOTIFICATIONS MANAGEMENT
      case 'admin-notifications':
        return requireAuth('admin',
          <ComponentWrapper componentName="AdminNotifications">
            <AdminNotifications onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      // 📚 E-LEARNING MANAGEMENT
      case 'admin-elearning':
        return requireAuth('admin',
          <ComponentWrapper componentName="AdminElearning">
            <AdminElearning onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      // 🏖️ HOLIDAY CALENDAR MANAGEMENT
      case 'admin-holidays':
        return requireAuth('admin',
          <ComponentWrapper componentName="AdminHolidayManage">
            <AdminHolidayManage onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      // ==========================================
      // PARENT DASHBOARD ROUTES
      // ==========================================
      case 'parent-dashboard':
        return requireAuth('parent',
          <ComponentWrapper componentName="ParentDashboard">
            <ParentDashboard onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'parent-academic-performance':
        return requireAuth('parent',
          <ComponentWrapper componentName="ParentAcademicPerformance">
            <ParentAcademicPerformance onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'parent-fees-status':
        return requireAuth('parent',
          <ComponentWrapper componentName="ParentFeesStatus">
            <ParentFeesStatus onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'parent-holidays':
        return requireAuth('parent',
          <ComponentWrapper componentName="ParentHolidays">
            <ParentHolidays onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'parent-emergency-alert':
        return requireAuth('parent',
          <ComponentWrapper componentName="ParentEmergencyAlert">
            <ParentEmergencyAlert onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      // ==========================================
      // ACCOUNTS DASHBOARD ROUTES
      // ==========================================
      case 'accounts-dashboard':
        return requireAuth('accounts',
          <ComponentWrapper componentName="AccountsDashboard">
            <AccountsDashboard onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'accounts-salary-counter':
        return requireAuth('accounts',
          <ComponentWrapper componentName="AccountsSalaryCounter">
            <AccountsSalaryCounter onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'accounts-reports':
        return requireAuth('accounts',
          <ComponentWrapper componentName="AccountsReports">
            <AccountsReports onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'accounts-certificates':
        return requireAuth('accounts',
          <ComponentWrapper componentName="AccountsCertificates">
            <AccountsCertificates onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'accounts-inventory':
        return requireAuth('accounts',
          <ComponentWrapper componentName="AccountsInventory">
            <AccountsInventory onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'accounts-performance':
        return requireAuth('accounts',
          <ComponentWrapper componentName="AccountsPerformance">
            <AccountsPerformance onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'accounts-work-orders':
        return requireAuth('accounts',
          <ComponentWrapper componentName="AccountsWorkOrders">
            <AccountsWorkOrders onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'accounts-vendor-management':
        return requireAuth('accounts',
          <ComponentWrapper componentName="AccountsVendorManagement">
            <AccountsVendorManagement onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );



      case 'accounts-fee-manage':
        return requireAuth('accounts',
          <ComponentWrapper componentName="AccountsFeeManage">
            <AccountsFeeManage onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'accounts-fee-structures':
        return requireAuth('accounts',
          <ComponentWrapper componentName="AccountsFeeStructure">
            <AccountsFeeStructure onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'vendor-dashboard':
        return requireAuth('vendor',
          <ComponentWrapper componentName="VendorDashboard">
            <VendorDashboard onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'live-bidding':
        return requireAuth('vendor',
          <ComponentWrapper componentName="LiveBidding">
            <LiveBidding onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );
      case 'my-bids':
        return requireAuth('vendor',
          <ComponentWrapper componentName="VendorMyBids">
            <VendorMyBids onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      // ==========================================
      // LIBRARY DASHBOARD ROUTES (Protected - Librarian Role)
      // ==========================================
      case 'library-dashboard':
        return requireAuth('librarian',
          <ComponentWrapper componentName="LibraryDashboard">
            <LibraryDashboard onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'library-new-arrivals':
        return requireAuth('librarian',
          <ComponentWrapper componentName="LibraryNewArrivals">
            <LibraryNewArrivals onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'library-catalog':
        return requireAuth('librarian',
          <ComponentWrapper componentName="LibraryCatalog">
            <LibraryCatalog onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'library-categories':
        return requireAuth('librarian',
          <ComponentWrapper componentName="LibraryCategories">
            <LibraryCategories onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'library-issue':
        return requireAuth('librarian',
          <ComponentWrapper componentName="LibraryIssue">
            <LibraryIssue onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'library-return':
        return requireAuth('librarian',
          <ComponentWrapper componentName="LibraryReturn">
            <LibraryReturn onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'library-members':
        return requireAuth('librarian',
          <ComponentWrapper componentName="LibraryMembers">
            <LibraryMembers onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'library-requests':
        return requireAuth('librarian',
          <ComponentWrapper componentName="LibraryRequests">
            <LibraryRequests onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'library-overdue':
        return requireAuth('librarian',
          <ComponentWrapper componentName="LibraryOverdue">
            <LibraryOverdue onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      case 'library-fines':
        return requireAuth('librarian',
          <ComponentWrapper componentName="LibraryFines">
            <LibraryFines onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      // ==========================================
      // EXAM CELL ADMIT FORMAT ROUTE
      // ==========================================
      case 'examcell-admitformat':
        return (
          <ComponentWrapper componentName="ExamCellAdmitFormat">
            <ExamCellAdmitFormat onNavigate={handleNavigation} userInfo={userInfo} />
          </ComponentWrapper>
        );

      // ==========================================
      // SUPER ADMIN DASHBOARD
      // ==========================================
      case 'superadmin-dashboard':
        return requireAuth('superadmin',
          <ComingSoonDashboard
            userType="Super Admin"
            onNavigate={handleNavigation}
            userInfo={userInfo}
            pageName="Super Admin Control Panel"
          />
        );

      // ==========================================
      // DEFAULT ROUTE
      // ==========================================
      default:
        // console.log(`❓ Unknown page: ${currentPage}, redirecting to home`);
        return (
          <ComponentWrapper componentName="LandingPage">
            <LandingPage onNavigate={handleNavigation} />
          </ComponentWrapper>
        );
    }
  };

  // ==========================================
  // RENDER APP
  // ==========================================
  return (
    <div className="App">
      {renderCurrentPage()}
    </div>
  );
}

export default App;